export const NHAPKHO_LIST_INITING         = 'NHAPKHO_LIST_INITING'

export const NHAPKHO_LIST_NCC_REQUESTING      = 'NHAPKHO_LIST_NCC_REQUESTING'
export const NHAPKHO_LIST_NCC_SUCCESS         = 'NHAPKHO_LIST_NCC_SUCCESS'
export const NHAPKHO_LIST_NCC_ERROR           = 'NHAPKHO_LIST_NCC_ERROR'   

export const NHAPKHO_LIST_KHO_REQUESTING      = 'NHAPKHO_LIST_KHO_REQUESTING'
export const NHAPKHO_LIST_KHO_SUCCESS         = 'NHAPKHO_LIST_KHO_SUCCESS'
export const NHAPKHO_LIST_KHO_ERROR           = 'NHAPKHO_LIST_KHO_ERROR'

export const NHAPKHO_LIST_PRODUCT_REQUESTING      = 'NHAPKHO_LIST_PRODUCT_REQUESTING'
export const NHAPKHO_LIST_PRODUCT_SUCCESS         = 'NHAPKHO_LIST_PRODUCT_SUCCESS'
export const NHAPKHO_LIST_PRODUCT_ERROR           = 'NHAPKHO_LIST_PRODUCT_ERROR'   

export const NHAPKHO_SAVE_REQUESTING      = 'NHAPKHO_SAVE_REQUESTING'
export const NHAPKHO_SAVE_SUCCESS         = 'NHAPKHO_SAVE_SUCCESS'
export const NHAPKHO_SAVE_ERROR           = 'NHAPKHO_SAVE_ERROR'  
 
export const NHAPKHO_DETAIL_REQUESTING      = 'NHAPKHO_DETAIL_REQUESTING'
export const NHAPKHO_DETAIL_SUCCESS         = 'NHAPKHO_DETAIL_SUCCESS'
export const NHAPKHO_DETAIL_ERROR           = 'NHAPKHO_DETAIL_ERROR'    

export const NHAPKHO_UPDATE_REQUESTING      = 'NHAPKHO_UPDATE_REQUESTING'
export const NHAPKHO_UPDATE_SUCCESS         = 'NHAPKHO_UPDATE_SUCCESS'
export const NHAPKHO_UPDATE_ERROR           = 'NHAPKHO_UPDATE_ERROR'   

export const NHAPKHO_PRODUCTS_LIST_DVT_REQUESTING    = 'NHAPKHO_PRODUCTS_LIST_DVT_REQUESTING'
export const NHAPKHO_PRODUCTS_LIST_DVT_SUCCESS       = 'NHAPKHO_PRODUCTS_LIST_DVT_SUCCESS'
export const NHAPKHO_PRODUCTS_LIST_DVT_ERROR         = 'NHAPKHO_PRODUCTS_LIST_DVT_ERROR' 

export const NHAPKHO_GEN_BARCODE_REQUESTING      = 'NHAPKHO_GEN_BARCODE_REQUESTING'
export const NHAPKHO_GEN_BARCODE_SUCCESS         = 'NHAPKHO_GEN_BARCODE_SUCCESS'
export const NHAPKHO_GEN_BARCODE_ERROR           = 'NHAPKHO_GEN_BARCODE_ERROR' 

export const NHAPKHO_DUYET_REQUESTING      = 'NHAPKHO_DUYET_REQUESTING'
export const NHAPKHO_DUYET_SUCCESS         = 'NHAPKHO_DUYET_SUCCESS'
export const NHAPKHO_DUYET_ERROR           = 'NHAPKHO_DUYET_ERROR'

export const NHAPKHO_HUY_DUYET_REQUESTING      = 'NHAPKHO_HUY_DUYET_REQUESTING'
export const NHAPKHO_HUY_DUYET_SUCCESS         = 'NHAPKHO_HUY_DUYET_SUCCESS'
export const NHAPKHO_HUY_DUYET_ERROR           = 'NHAPKHO_HUY_DUYET_ERROR'

export const LOAD_KHACH_HANG           = 'NHAPKHO.LOAD_KHACH_HANG'

export const LOAI_DH = {
  TU_NCC: 0,
  DON_THUONG: 1,
  DON_DAI_LY: 2
}

export const NHAPKHO_LIST_PRODUCT_API       = '/api/v1/import/list_hang_for_import_by' 
export const NHAPKHO_LIST_NCC_API           = '/api/v1/management/nhacc_list_by_store'
export const NHAPKHO_LIST_KHO_API           = '/api/v1/management/kho_cap_list_by_store_user'
export const NHAPKHO_PRODUCTS_LIST_DVT_API  = '/api/v1/management/get_list_dvt'
export const NHAPKHO_GEN_BARCODE_API        = '/api/v1/import/gen_barcode_auto'
//===New=====//
export const NHAPKHO_SAVE_API               = '/api/v1/import/save_nhapkho'
//===Edit=====//
export const NHAPKHO_DETAIL_API             = '/api/v1/import/details'
export const NHAPKHO_UPDATE_API             = '/api/v1/import/update_nhap'
//===Duyet=====//
export const NHAPKHO_DUYET_API             = '/api/v1/import/duyet_nhap'
//===Huy Duyet=====//
export const NHAPKHO_HUY_DUYET_API         = '/api/v1/import/huy_duyet'
//===get all khach hang/ kho
export const NHAPKHO_LOAD_KHACHHANG_API         = '/api/v1/import/khach_hang_suggestion'

  
 


// WEBPACK FOOTER //
// ./src/views/NhapKho/constants.js